module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.$utils.isCartOfflineShippable() && _vm.$utils.getShippingDetail().length > 0) ? _c('div', {
    staticClass: "block"
  }, [_c('strong', [_vm._v("วิธีการรับ" + _vm._s(_vm.$config.PRODUCT_TYPE))]), _vm._v(" "), _c('ul', _vm._l((_vm.$utils.getShippingDetail()), function(detail) {
    return _c('li', [_vm._v(_vm._s(detail))])
  }), 0)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-66fb9efc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66fb9efc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeliverySelector.vue
// module id = 746
// module chunks = 1